// extracted by mini-css-extract-plugin
export default {"formContainer":"styles__formContainer___3IKAt","spacer":"styles__spacer___3z6co"};